import { useEffect, useState } from 'react';

/** Khổ màn của board: điện thoại (< 768) · iPad (768–1279) · máy bàn (≥ 1280). */
export type Layout = 'phone' | 'ipad' | 'desktop';

const PHONE = '(max-width: 767px)';
const IPAD = '(max-width: 1279px)';

const read = (): Layout => (matchMedia(PHONE).matches ? 'phone' : matchMedia(IPAD).matches ? 'ipad' : 'desktop');

export function useLayout(): Layout {
  const [layout, setLayout] = useState<Layout>(read);
  useEffect(() => {
    const a = matchMedia(PHONE);
    const b = matchMedia(IPAD);
    const on = () => setLayout(read());
    a.addEventListener('change', on);
    b.addEventListener('change', on);
    return () => {
      a.removeEventListener('change', on);
      b.removeEventListener('change', on);
    };
  }, []);
  return layout;
}
